import { encodeRecordId } from '../utils/recordIds';

/** Deep links to a student / family fiche (refresh-safe, shareable). */
export const RECORD_PATH = Object.freeze({
  STUDENTS: '/students',
  FAMILIES: '/families',
  STUDENT_DETAIL: '/students/:studentId',
  FAMILY_DETAIL: '/families/:familyId',
  LEGACY_STUDENT_DETAIL: '/students/detail',
  LEGACY_FAMILY_DETAIL: '/families/detail',
});

/** Static children of /students and /families: never a masked id. */
const STATIC_SEGMENTS = new Set(['add', 'edit', 'detail']);

export const studentPath = (id) => `${RECORD_PATH.STUDENTS}/${encodeRecordId(id)}`;
export const familyPath = (id) => `${RECORD_PATH.FAMILIES}/${encodeRecordId(id)}`;

/** Family fiche opened on a tab (`?tab=`), e.g. the family space invitation. */
export const FAMILY_TAB_PARAM = 'tab';
export const FAMILY_SPACE_TAB = 'espace';
export const familySpacePath = (id) => `${familyPath(id)}?${FAMILY_TAB_PARAM}=${FAMILY_SPACE_TAB}`;

const DETAIL_PATTERNS = [
  [/^\/students\/([0-9a-z]+)\/?$/, RECORD_PATH.LEGACY_STUDENT_DETAIL],
  [/^\/families\/([0-9a-z]+)\/?$/, RECORD_PATH.LEGACY_FAMILY_DETAIL],
];

/** Collapses `/students/<masked id>` to the generic detail key used by first-use guides. */
export const guidePathFor = (pathname) => {
  const match = DETAIL_PATTERNS.find(([pattern]) => {
    const segment = pathname.match(pattern)?.[1];
    return segment && !STATIC_SEGMENTS.has(segment);
  });
  return match ? match[1] : pathname;
};
